export const emailRegex = /^[\w\-\\.+'`ʼ]+@([\w-]+\.)+[\w-]{2,}$/;
export const nameRegex = /^[a-zA-Z '"`ʼ\-_)(]{1,30}$/;
export const mfaCodeRegex = /^[0-9]{6}$/;
export const frameworkAnswerForbiddenSymbolsRegex = /^\[ ]+$/;
export const forbiddenHexSymbolsRegex = /[^A-F\d]/;
